export const getRiskThreshold = state => state?.thresholds?.risk_threshold
export const getOverheadAndProfitThreshold = state => state?.thresholds?.overhead_and_profit_threshold
export const getPreliminariesThreshold = state => state?.thresholds?.preliminaries_threshold
export const getEnablingWorksThreshold = state => state?.thresholds?.enabling_works_threshold
export const getFitOutThreshold = state => state?.thresholds?.fit_out_threshold
export const getMepThreshold = state => state?.thresholds?.mep_threshold
export const getSubstructureThreshold = state => state?.thresholds?.substructure_threshold
export const getSuperstructureThreshold = state => state?.thresholds?.superstructure_threshold
export const getOtherWorksThreshold = state => state?.thresholds?.other_works_threshold